import { sendToApi } from 'api/client'
import { AlmanacFile, ContentCampaign, ViewType } from 'types'
import { ChannelOption } from 'components/Wizards/CampaignWizard/Types'
import { Tone } from 'components/DocRightRail/screens/AIAssistant/ToneSelect'
import { CampaignType } from './Types'

export interface CreateCampaignPayload {
  workspaceId: number
  name?: string
  focus?: string
  brand_voice_id?: number
  tones?: Array<string>
  project_key?: string
  brand_kit_id?: number
  brand_visual_kit_id?: number
}

export const createCampaignRequest = (payload: CreateCampaignPayload) => {
  const { workspaceId, ...body } = payload
  return sendToApi<{ content_campaign: ContentCampaign }>(`/w/${workspaceId}/content_campaigns`, {
    method: 'POST',
    body,
  })
}

export interface GenerateCampaignDocsPayload {
  workspaceId: number
  campaign_id: number
  campaign_type: CampaignType
  channels: Array<ChannelOption> | Array<string>
  external_integration_id?: number | null
  redirect_to_view?: ViewType
  prompt: {
    seo_words?: Array<string>
    tone?: Array<Tone>
    brand_voice_id?: number
    goal?: string
    audience?: string
    source_materials?: number[]
    call_to_action?: string
    author_persona?: string
    product_description?: string
    avoid?: string
    additional_info?: string
    topic?: string
    product_name?: string
    reference_text?: string
    language?: string
    blog_length?: string
    include_images?: boolean
    featured_selected_images?:
      | Array<{
          url: string
          alt_text: string
        }>
      | string[]
    transcription_id?: number
    promotion?: string
    brand_kit_id?: number
    brand_visual_kit_id?: number
  }
}

export const generateDocsRequest = (payload: GenerateCampaignDocsPayload) => {
  const { workspaceId, ...rest } = payload
  return sendToApi<{ almanac_file: AlmanacFile }>(`/w/${workspaceId}/generate_campaign`, {
    method: 'POST',
    body: rest,
  })
}
